import { BasicDoctorInfo, BasicDoctorInfoWithClinics } from "@elixir/types";
import getB from "../../utils/bridges/EkaBridge";
import { MyProfileResponse } from "../../utils/bridges/types/doctorProfile";

export type BasicDoctorInfoWithClinicsAndName = BasicDoctorInfo & {
  clinics: { id: string; name: string }[];
};
export interface MassagedProfileForSelector {
  doctors: BasicDoctorInfoWithClinicsAndName[];
  allDocs: BasicDoctorInfoWithClinics[];
  clinics: MyProfileResponse["clinics"];
  business: MyProfileResponse["business"];
  loginmeta: MyProfileResponse["loginmeta"];
  user: MyProfileResponse["user"];
  hasAccessToMultipleDoctors?: boolean;
}

export const docListMassaged = () => {
  const myProfile = getB()?.getMe();

  const massagedProfile: MassagedProfileForSelector = {
    allDocs:
      myProfile.docs?.map((item) => ({
        name: `${item.personal.s || "Dr."} ${item.personal.name.f || ""} ${
          item.personal.name.l || ""
        }`.trim(),
        oid: item.id,
        pic:
          item.personal.pic ||
          "https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png",
        username: item.professional.username,
        clinics: item.professional.clinics.map((item) => item._id),
        default_clinic: item.professional.default_clinic,
      })) || [],
    doctors:
      myProfile.docs?.map((item) => ({
        name: `${item.personal.s || "Dr."} ${item.personal.name.f || ""} ${
          item.personal.name.l || ""
        }`.trim(),
        oid: item.id,
        pic:
          item.personal.pic ||
          "https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png",
        username: item.professional.username,
        clinics: item.professional.clinics.map((c) => ({
          ...c,
          id: c._id,
          name: c.name || "",
        })),
      })) || [],
    clinics: myProfile.clinics,
    business: {
      ...myProfile?.business,
      id: myProfile?.business?.id || `b-${myProfile.loginmeta.docid}`,
    },
    loginmeta: myProfile.loginmeta,
    user: myProfile.user,
  };
  return massagedProfile;
};
